import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import type { DisplayedSubjectQuote } from '../../../types';
import { keys } from './keys';

async function fetchSubTopicQuotes(subTopicId: string): Promise<DisplayedSubjectQuote[]> {
  const { data, error } = await apiClient
    .from('subject_quotes')
    .select(`
      *,
      providers (id, name),
      documents (
        *,
        document_types (id, name)
      )
    `)
    .eq('subject_id', subTopicId)
    .order('date_received', { ascending: false });

  if (error) {
    throw error;
  }

  return (data as unknown as DisplayedSubjectQuote[]) ?? [];
}

export function useGetSubTopicQuotes(subTopicId: string | undefined) {
  return useQuery({
    queryKey: keys.subTopicQuotes(subTopicId ?? ''),
    queryFn: () => fetchSubTopicQuotes(subTopicId!),
    enabled: !!subTopicId,
  });
}
